<template>
  <ul class="card-portals">
    <li
      v-for="(portal, index) in fields"
      :key="`card-portals-field-${index}`"
      class="card-portals__field"
    >
      <p class="card-portals__label">{{ getPortalName(portal) }}</p>
      <div class="card-portals__data">
        <span :class="getPortalTagClass(portal)" class="card-portals__status">{{
          getPortalStatus(portal)
        }}</span>
        ({{ $t(`DASHBOARD.CARD.EXPANDED.PORTAL.STATUS.${portal.rotation_type.toUpperCase()}`) }})
        <a v-if="portal.link" class="card-portals__link" :href="portal.link" target="_blank">
          <HdIcon :src="icons.openInNew" height="20" width="20" />
        </a>
      </div>
    </li>
  </ul>
</template>

<script>
import { HdIcon } from 'homeday-blocks';
import { openInNew } from 'homeday-assets';

export default {
  name: 'CardPortals',
  components: { HdIcon },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icons() {
      return {
        openInNew,
      };
    },
    fields() {
      return this.deal?.portals?.filter((portal) => portal.listing_status);
    },
  },
  methods: {
    getPortalName(portal) {
      return this.$t(`DASHBOARD.CARD.EXPANDED.PORTAL.${portal.name.toUpperCase()}`);
    },
    getPortalTagClass(portal) {
      return portal.listing_status === 'online'
        ? 'card-portals__tag--onlineGreen'
        : 'card-portals__tag--offlineRed';
    },
    getPortalStatus(portal) {
      return this.$t(`DASHBOARD.CARD.${portal.listing_status === 'online' ? 'ON' : 'OFF'}LINE`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.card-portals {
  ::v-deep &__link svg > path {
    fill: getShade($secondary-color, 120);
  }

  &__link {
    display: flex;
  }

  &__field {
    @include font('DS-90');
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: $sp-xxs;
    justify-content: space-between;

    &:not(:last-child) {
      margin-bottom: $sp-s;

      @include for('tablet') {
        margin-bottom: $sp-m;
      }
    }

    @include for('tablet') {
      @include font('DS-100');
      gap: $sp-s;
    }
  }

  &__status {
    @include font('DS-80');
    border-radius: $sp-s;
    height: max-content;
    padding: $sp-xxs $sp-s - $sp-xxs;

    @include for('tablet') {
      @include font('DS-100');
      padding: $sp-xs $sp-s + $sp-xs;
    }
  }

  &__label {
    @include font('DS-90');
    font-weight: 700;

    @include for('tablet') {
      @include font('DS-100');
    }
  }

  &__data {
    align-items: center;
    display: flex;
    gap: $sp-xs;
    width: 165px;

    @include for('tablet') {
      gap: $sp-s;
      width: unset;
    }
  }

  &__tag--onlineGreen {
    background-color: $apple-green;
    color: $primary-bg;
  }

  &__tag--offlineRed {
    background-color: $error-color;
    color: $primary-bg;
  }
}
</style>
